import React from 'react';
import { connect } from "react-redux";
import { getAge } from "../../../helpers/dateTime";
import { Link , useLocation } from "react-router-dom";
import * as Tools from "../../../helpers/Tools";
import ConfirmationModal from "../../common/ConfirmationModal";
import * as types from "../../../constants/actionTypes";
import * as queryString from 'query-string';
import AccessDOB from '../../common/AccessDOB';
import { logUI } from "../../../api/andyliticsApi";
import * as ProxyHelper from "../ProxyHelper";

const dobInputId = "dobInput";
class ProxyRequestDob extends React.Component {
    constructor(props) {
        super(props);
        const { dateOfBirth, match, history, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let prefillData = this.getPrefillData(listOfSelectedProxyUsers);
        let prefillDOB = this.getPrefillDOB(prefillData);
        const searchParams = props.location ? props.location.searchParams ? queryString.parse(props.location.searchParams) : props.location.search ? queryString.parse(props.location.search) : null : null;
        if (searchParams && searchParams.fromNoProxy) {
            this.fromEvisit = JSON.parse(searchParams.fromNoProxy);
        } else {
            this.fromEvisit = false;
        }

        let accessType = null , dcjEnrollment = null, patientName = null;
        accessType = match && match.params && match.params.accesstype ? match.params.accesstype : searchParams && searchParams.accesstype ? searchParams.accesstype : null;
        dcjEnrollment = match && match.params && match.params.dcjenrollment ? match.params.dcjenrollment : searchParams && searchParams.dcjenrollment ? searchParams.dcjenrollment : null;
        patientName = match && match.params && match.params.patientname ? match.params.patientname : searchParams && searchParams.patientname ? searchParams.patientname : null;
        if (accessType) {
            switch (accessType.toLowerCase()) {
                case "both": {
                    this.isPharmacySelectedDefault = true;
                    this.isHrSelectedDefault = true;
                    break;
                }
                case "hr": {
                    this.isPharmacySelectedDefault = false;
                    this.isHrSelectedDefault = true;
                    break;
                }
                case "pharmacy": {
                    this.isPharmacySelectedDefault = true;
                    this.isHrSelectedDefault = false;
                    break;
                }
                default:
                    this.isPharmacySelectedDefault = false;
                    this.isHrSelectedDefault = false;
            }
        }
        else {
            this.isPharmacySelectedDefault = false;
            this.isHrSelectedDefault = false;
        }

        this.isFromInHome = !!searchParams?.isFromInHome
        this.isDcjEnrollment = dcjEnrollment && dcjEnrollment.toLowerCase() === "minor" ? true : false;
        this.patientName = patientName;
        let prefillDataCondition = useOnboardingLayout && listOfSelectedProxyUsers?.length > 0 
        this.state = {
            dateOfBirth: prefillDataCondition ? prefillDOB: dateOfBirth && this.fromEvisit === false ? dateOfBirth : "",
            validDob: true,
            mounted: false,
            isMinor: true,
            validationError: "",
            isSubmit: false
        };
        this.handleValidationAndOnContinueClick = this.handleValidationAndOnContinueClick.bind(this);
        this.inputId = dobInputId;
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.RequestAccessDOB.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}${this.isFromInHome ? '.FromInHome' : ''}`, new Date(), Tools.getURLPath());
        const { location } = this.props;
        this.setState({ mounted: true, isSubmit: false });
        if (location && location.pathname && location.pathname.toLowerCase() && location.pathname.toLowerCase().indexOf("/requestdcjproxy") >= 0)
            logUI(`MBHWeb.UI.ProxyRequestDob.RequestDcjProxy.Loaded${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    handleValidationAndOnContinueClick(event) {
        const { mounted, dateOfBirth } = this.state;
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const pathName = useOnboardingLayout ? '/onboarding/proxyrequest' : '/proxyrequest';
        let prefillData = this.getPrefillData(listOfSelectedProxyUsers);
        this.setState({ isSubmit: true }, () => {
            if (mounted) {
                if (this.isValidate()) {
                    this.props.updateRequestData(dateOfBirth);                    
                    useOnboardingLayout && this.UpdatePreference("ContinueButton");

                    this.props.history.push({
                        pathname: pathName, searchParams: `fromNoProxy=${this.fromEvisit}&isPharmacySelectedDefault=${this.isPharmacySelectedDefault}&isHrSelectedDefault=${this.isHrSelectedDefault}&isDcjEnrollment=${this.isDcjEnrollment}&isFromInHome=${this.isFromInHome}`,
                        state: {prefillDetails:prefillData}
                    });
                }
            }
        });
    }

    isValidate() { //call this to validate date before going further to next page.
        const { mounted, dateOfBirth } = this.state;
        if (mounted) {
            let validDob;
            validDob = this.isValidDate(dateOfBirth);//check valid date instead of length, this is required as isValid on input change is not actually validating.
            if (validDob !== this.state.validDob) {
                this.setState({ validDob });
            }
            if (!validDob) this.inputId = dobInputId;
            return validDob;
        }
    }

    isValidDate(dateValue) {
        const dateToday = new Date();
        const minDate = new Date(dateToday.setFullYear(dateToday.getFullYear() - 140));
        return (!minDate || Tools.dateStringFormat(dateValue) >= Tools.dateStringFormat(minDate)) && (Tools.dateStringFormat(dateValue) <= Tools.dateStringFormat(new Date()));
    }

    onInputChange = (field, value, isValid) => {
        if (value) {
            if (typeof isValid === 'undefined' || isValid) {
                const isMinor = getAge(value) < 18;
                this.setState({ [field]: value, isMinor, validDob: isValid }, () => {
                    this.isValidate();
                });
            }
            else {
                this.isValidate();
            }
        } else {
            this.setState({ [field]: value });
        }
    }

    setValidationMessage(sMessage) {
        const { validationError, mounted } = this.state;
        if (mounted && validationError !== sMessage) {
            this.setState({ validationError: sMessage });
        } else {
            this.setState({ validationError: "" });
        }
    }

    dataEntered() {
        const { dateOfBirth } = this.state;
        let entered = false;
        if (dateOfBirth && dateOfBirth !== "") {
            entered = true;
        }
        return entered;
    }

    //Update Preference, and set it to 'false', when 'Skip' is clicked
    UpdatePreference(linkName) {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.RequestAccessDOB.UpdatePreference.${linkName}${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        if (!count) {
            this.props.updateFamilyMembersScreenPreference && this.props.updateFamilyMembersScreenPreference();
        }
    }

    getPrefillData(listOfSelectedProxyUsers) {
        let proxyFirstFlow = listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers.every((user) => user.isCompleted == false);
        let prefillData = proxyFirstFlow ?
            listOfSelectedProxyUsers && listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers :
            listOfSelectedProxyUsers && listOfSelectedProxyUsers?.length > 0 && listOfSelectedProxyUsers.filter((user) => user.isCompleted !== true);

        return prefillData;
    }

    getPrefillDOB(prefillData) {
        let prefillDOB = prefillData[0]?.proxyRequest?.receiver?.dateOfBirth && new Date(prefillData[0].proxyRequest.receiver.dateOfBirth).toLocaleDateString('en-US', {
            month: '2-digit', day: '2-digit', year: 'numeric'
        })

        return prefillDOB;
    }

    render() {
        const { validationError, isSubmit, dateOfBirth, validDob } = this.state;
        const { useOnboardingLayout, listOfSelectedProxyUsers, hasMyChartLogin, removeBSWPharmacy } = this.props;
        let prefillData = this.getPrefillData(listOfSelectedProxyUsers);
        let prefillDOB = this.getPrefillDOB(prefillData);
        let prefillDataCondition = useOnboardingLayout && listOfSelectedProxyUsers?.length > 0 

        return ((!removeBSWPharmacy || hasMyChartLogin) &&
            <div className="container-fluid body-content request-dob-container">
                <AccessDOB
                    dateOfBirth={prefillDataCondition ? prefillDOB : dateOfBirth}
                    validationError={validationError}
                    onInputChange={this.onInputChange}
                    validDob={validDob}
                    dobInputId={dobInputId}
                    handleValidationAndOnContinueClick={this.handleValidationAndOnContinueClick}
                    initializeRequestData={this.props.initializeRequestData}
                    dcjEnrollment={this.isDcjEnrollment}
                    patientName={this.patientName}
                    prefillDetails={prefillData}
                />
                <ConfirmationModal when={this.dataEntered() && !isSubmit && !useOnboardingLayout} />
                {useOnboardingLayout &&
                    <div className="row">
                    <div className="col-12 text-center maxWidth-content">
                            <Link to={{ pathname: '/onboarding/managenotifications' }}
                                className="btn text-btn"
                                onClick={() => { this.UpdatePreference('Skip'); }}>
                                SKIP THIS STEP
                        </Link>
                        </div>
                    </div>
                }
            </div>
        );
    };
}

const mapStateToProps = (state) => {
    const requestData = state.common[types.PROXY_REQUEST_DATA];
    let dob = requestData && requestData.pData && requestData.pData.dateOfBirth ? requestData.pData.dateOfBirth : "";
    return {
        dateOfBirth: dob,
        useOnboardingLayout: state.session.useOnboardingLayout,
        listOfSelectedProxyUsers: state.session.selectedProxySuggestionUsers,
        hasMyChartLogin: !state.common.epicEHRDown && state.domain.hm,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};


const mapDispatchToProps = (dispatch) => ({
    updateRequestData: (dateOfBirth) => {
        dispatch({ type: types.PROXY_REQUEST_DATA, pData: { dateOfBirth: dateOfBirth } });
    },
    initializeRequestData: () => {
        dispatch({ type: types.PROXY_REQUEST_DATA, pData: {} });
    },
    updateFamilyMembersScreenPreference: () => {
        dispatch({ type: types.UPDATE_FAMILYMEMBERS_SCREEN_PREFERENCE });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProxyRequestDob);